import { Icon } from '@/common/components/Icons/Icon';
import { PLAN } from '@/common/constants/markets';
import { useEmployeeDetails } from '@/common/contexts/user/UserDetailsContext';
import { IFamilyMember } from '@/common/integrations/menhir/employee/employee/employee.types';
import { DateUtils } from '@/common/utils/date';

export const MAX_CHILD_AGE_PT = 6;
export const MAX_CHILD_AGE_ES = 3;

export const isValidBirthDate = (birthDate: string) =>
  DateUtils.getYearsDifferenceFromToday(birthDate) <= MAX_CHILD_AGE_PT;

export const isValidChildAge = (child: IFamilyMember) =>
  DateUtils.getYearsDifferenceFromToday(child.birthdate) <= MAX_CHILD_AGE_PT;

export const isChildEligibleForChildcare = (
  child: IFamilyMember,
  maxChildAge: number
) => {
  return DateUtils.getYearsDifferenceFromToday(child.birthdate) <= maxChildAge;
};

export const determineEligibleChildcareMembers = (
  members: IFamilyMember[],
  maxChildAge: number
) => {
  return members.filter(
    (member) =>
      member.type === 'child' &&
      isChildEligibleForChildcare(member, maxChildAge)
  );
};

export const getMemberIconByAge = (birthdate: string, iconSize?: number) => {
  const age = DateUtils.getYearsDifferenceFromToday(birthdate);

  if (age <= 2) {
    return <Icon icon="baby" size={iconSize} />;
  }
  if (age <= 12) {
    return <Icon icon="child" size={iconSize} />;
  }
  return <Icon icon="user" size={iconSize} />;
};

export function useCanEmployeeManageFamilyMembers() {
  const { company } = useEmployeeDetails();
  return [PLAN.WALLET, PLAN.ITALY_FULL, PLAN.ES_WALLET, PLAN.ES_HYBRID].some(
    (p) => p === company.settings?.plan
  );
}
